import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const CatalogDashboardPage = lazy(
  () => import("../../pages/faire/CatalogDashboardPage")
);
const PricingInsightsPage = lazy(
  () => import("../../pages/PricingInsightsPage")
);
const ProfitMarginCalculatorPage = lazy(
  () => import("../../pages/ProfitMarginCalculatorPage")
);
const CatalogScorecardPage = lazy(() => import("../../pages/CatalogScorecard"));
const CollapsibleBrandLeftNavPage = lazy(
  () => import("../../pages/CollapsibleBrandLeftNav")
);

export function BrooklynBrownRoutes() {
  return (
    <Switch>
      <Route path="/bb/catalog-scorecard" component={CatalogScorecardPage} />
      <Route
        exact
        path="/bb/faire/catalog-dashboard"
        component={CatalogDashboardPage}
      />
      <Route path="/bb/pricing-insights" component={PricingInsightsPage} />
      <Route
        path="/bb/profit-margin-calculator"
        component={ProfitMarginCalculatorPage}
      />
      <Route
        path="/bb/collapsible-brand-left-nav"
        component={CollapsibleBrandLeftNavPage}
      />
    </Switch>
  );
}

export const slug = "bb";
